/* global _learnq, theme */

export default class Klaviyo {
  constructor() {
    this.listId = theme.klaviyoListId;
    this.eventDataArray = [];
  }

  init(email, firstName, lastName) {
    this.email = email;
    this.firstName = firstName;
    this.lastName = lastName;
  }

  subcribeToList() {
    if (!this.listId) {
      return;
    }

    var request = new XMLHttpRequest();
    var _this = this;
    var dataString =
      'g=' +
      this.listId +
      '&email=' +
      encodeURIComponent(this.email) +
      '&first_name=' +
      this.firstName +
      '&last_name=' +
      this.lastName;

    request.open(
      'POST',
      'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
      true
    );
    request.setRequestHeader(
      'Content-Type',
      'application/x-www-form-urlencoded; charset=UTF-8'
    );
    request.send(dataString);
    request.onreadystatechange = function () {
      var DONE = 4; // readyState 4 means the request is done.
      var OK = 200; // status 200 is a successful return.
      if (request.readyState === DONE) {
        if (request.status === OK) {
          _this.success();
        } else {
          _this.error();
        }
      }
    };
  }

  identifyUser() {
    // adds the user to Klaviyo
    _learnq.push([
      'identify',
      {
        $email: this.email,
      },
    ]);
  }

  appendCustomProperty(key, value) {
    var appendData = {};
    appendData[key] = value;

    _learnq.push([
      'identify',
      {
        $email: this.email,
        $append: appendData,
      },
    ]);
  }

  trackEvent(name, data) {
    setTimeout(function () {
      // adds an event to the user profile
      _learnq.push(['track', name, data]);
    }, 1000);
  }

  success() {
    // this.identifyUser();
  }

  error() {
    alert(unescape(pinCampaignFormStrings.strings.generalError));
  }
}
